import React, { Component } from 'react';
import {
  Collapse,
  Container,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import { LinkContainer } from 'react-router-bootstrap';
import { Route } from 'react-router';
import cx from 'classnames';
import { connect } from 'react-redux';

// decorators
import withTheme from '../../decorators/with-theme';
import withLocale from '../../decorators/with-locale';

// modules
import styles from '../Containers.module.scss';
import BS from '../../theme/Bootstrap';

// ducks
import { LOAD_FAVORITES } from '../../ducks/FavoriteSearch';

// images
import logoHomepage from './images/Logo_NaplesArea_Orange.png';
import logoRest from './images/Logo_NaplesArea_OrangeFull.png';

class AppHeader extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    const locale = this.context.locale;
    const { numFavorites } = this.props;

    return (
      <Route exact path="/">
        {({ match }) => (
          <Navbar
            color="white"
            light
            expand="md"
            className={cx(styles.header, {
              [styles.headerHome]: !!match
            })}
          >
            <Container>
              <NavbarToggler onClick={this.toggle} />
              <LinkContainer to="/">
                <NavbarBrand href="/" className={styles.brand}>
                  <img
                    src={match ? logoHomepage : logoRest}
                    alt="Nabor Logo - Orange Map Pin"
                  />
                </NavbarBrand>
              </LinkContainer>
              <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className="ml-auto" navbar>
                  <LinkContainer exact to="/">
                    <NavItem>
                      <NavLink href="/">{locale('header.Home')}</NavLink>
                    </NavItem>
                  </LinkContainer>
                  <LinkContainer to="/find-naples-home">
                    <NavItem>
                      <NavLink href="/find-naples-home">
                        {locale('header.Property Search')}
                      </NavLink>
                    </NavItem>
                  </LinkContainer>
                  <LinkContainer to="/find-naples-agent">
                    <NavItem>
                      <NavLink href="/find-naples-agent">
                        {locale('header.Find a REALTOR®')}
                      </NavLink>
                    </NavItem>
                  </LinkContainer>
                  <LinkContainer to="/blog">
                    <NavItem>
                      <NavLink href="/blog">{locale('header.Blog')}</NavLink>
                    </NavItem>
                  </LinkContainer>
                  <LinkContainer to="/resources">
                    <NavItem>
                      <NavLink href="/resources">{locale('header.Resources')}</NavLink>
                    </NavItem>
                  </LinkContainer>
                  <NavItem className={`${BS.dNone} ${BS.dMdListItem}`}>
                    <NavLink tag="span" className={styles.noInteraction}>
                      ::
                    </NavLink>
                  </NavItem>
                  <LinkContainer to="/favorites">
                    <NavItem>
                      <LinkContainer to="/favorites" activeClassName={styles.active}>
                        <NavLink href="/favorites" className={cx(styles.favoritesLink)}>
                          <MaterialIcon icon="star_border" />
                          <MaterialIcon icon="star" />
                          <span>
                            {locale('header.Favorites')} ({numFavorites})
                          </span>
                        </NavLink>
                      </LinkContainer>
                    </NavItem>
                  </LinkContainer>
                </Nav>
              </Collapse>
            </Container>
          </Navbar>
        )}
      </Route>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.pathname !== this.props.pathname) {
      this.setState({
        isOpen: false
      });
    }
  }

  componentDidMount() {
    const timer = setInterval(this.loadFavorites, 15 * 1000);
    this.setState({ timer });
    this.loadFavorites();
  }

  componentWillUnmount() {
    clearInterval(this.state.timer);
  }

  loadFavorites = () => {
    this.props.loadFavorites();
  };
}

export default connect(
  (state, props) => {
    return {
      numFavorites: state.FavoriteSearch.get('ids').length,
      pathname: state.routing.location.pathname
    };
  },
  {
    loadFavorites: LOAD_FAVORITES
  }
)(withLocale(withTheme(AppHeader)));



// WEBPACK FOOTER //
// ./src/containers/App/Header.js